type Input = {
  user: { email: string }
  orgName?: string
}

/**
 *
 * @param orgName - the current organisation name
 * @param user - a user with an email
 * Returns true if the user is an Omnean user in a production customer account
 */
export const isOmneanInProdCustomerAccount = ({ orgName, user }: Input): boolean =>
  !!(
    orgName &&
    orgName !== 'Omnea' &&
    !orgName.match(/^(.*ACME.*|.*test.*|.*sandbox.*|.* (QA|UAT))$/) &&
    user.email.match(/@omnea.co$/)
  )
